import { graphql } from '@/gql';

// --- Auth ---

export const LOGIN_MUTATION = graphql(`
    mutation Login($input: LoginInput!) {
        login(input: $input) {
            token
        }
    }
`);

export const REGISTER_MUTATION = graphql(`
    mutation Register($input: RegisterInput!) {
        register(input: $input) {
            token
            user {
                id
                username
            }
        }
    }
`);

export const LOGIN_WITH_STRAVA = graphql(`
    mutation LoginWithStrava($code: String!) {
        loginWithStrava(code: $code) {
            token
        }
    }
`);

export const LOGIN_WITH_GOOGLE = graphql(`
    mutation LoginWithGoogle($code: String!) {
        loginWithGoogle(code: $code) {
            token
        }
    }
`);

export const REQUEST_PASSWORD_RESET = graphql(`
    mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
        requestPasswordReset(input: $input)
    }
`);

export const RESET_PASSWORD = graphql(`
    mutation ResetPassword($input: ResetPasswordInput!) {
        resetPassword(input: $input) {
            token
        }
    }
`);

// --- Races ---

export const CREATE_RACE = graphql(`
    mutation CreateRace($input: CreateRaceInput!) {
        createRace(createRaceInput: $input) {
            id
            name
        }
    }
`);

export const CREATE_UTMB_RACE = graphql(`
    mutation CreateUtmbRace($input: CreateUtmbRaceInput!) {
        createUtmbRace(input: $input) {
            id
            name
        }
    }
`);

export const UPDATE_RACE = graphql(`
    mutation UpdateRace($id: ID!, $input: UpdateRaceInput!) {
        updateRace(id: $id, updateRaceInput: $input) {
            id
            name
            description
            raceFormat
            distance
            elevationGain
            bettingDeadline
            visibility
            status
            totalRunners
            bettingConfig { tokenCount }
        }
    }
`);

export const DELETE_RACE = graphql(`
    mutation DeleteRace($id: ID!) {
        deleteRace(id: $id)
    }
`);

export const SET_RACE_OFFICIAL = graphql(`
    mutation SetRaceOfficial($input: SetRaceOfficialInput!) {
        setRaceOfficial(input: $input) {
            id
            isOfficial
        }
    }
`);

export const UPDATE_INVITED_USER_ROLE = graphql(`
    mutation UpdateInvitedUserRole($input: UpdateInvitedUserRoleInput!) {
        updateInvitedUserRole(input: $input) {
            id
            invitedUsers {
                user { id username pictureUrl }
                role
            }
        }
    }
`);

// --- Runners ---

export const ADD_RUNNER = graphql(`
    mutation AddRaceRunner($input: AddRaceRunnerInput!) {
        addRaceRunner(addRaceRunnerInput: $input) {
            id
            runners { id utmbUri name }
        }
    }
`);

export const DELETE_RUNNER = graphql(`
    mutation DeleteRunner($id: ID!) {
        deleteRunner(id: $id)
    }
`);

// --- Bets ---

export const PLACE_BET = graphql(`
    mutation PlaceBet($input: PlaceBetInput!) {
        placeBet(placeBetInput: $input) {
            id
            rankings {
                runner { id name utmbIndex }
                position
                gender
                tokens
            }
            score
            createdAt
        }
    }
`);

// --- Join Race ---

export const JOIN_RACE_BY_CODE = graphql(`
    mutation JoinRaceByCode($code: String!) {
        joinRaceByCode(code: $code) {
            id
            name
        }
    }
`);

// --- Race Results ---

export const SUBMIT_RACE_RESULTS = graphql(`
    mutation SubmitRaceResults($submitRaceResultsInput: SubmitRaceResultsInput!) {
        submitRaceResults(submitRaceResultsInput: $submitRaceResultsInput) {
            id
            status
        }
    }
`);

export const CLOSE_RACE = graphql(`
    mutation CloseRace($raceId: ID!, $closingMessage: String) {
        closeRace(raceId: $raceId, closingMessage: $closingMessage) {
            id
            status
            closingMessage
        }
    }
`);

// --- UTMB Sync ---

export const SYNC_UTMB_RUNNERS = graphql(`
    mutation SyncUtmbRunners($input: SyncUtmbRunnersInput!) {
        syncUtmbRunners(input: $input) {
            created
            skipped
        }
    }
`);

export const SYNC_UTMB_RESULTS = graphql(`
    mutation SyncUtmbResults($input: SyncUtmbResultsInput!) {
        syncUtmbResults(input: $input) {
            updated
            notInDb
        }
    }
`);

// --- Profile ---

export const UPDATE_PROFILE = graphql(`
  mutation UpdateProfile($input: UpdateUserInput!) {
    updateUser(updateUserInput: $input) {
      id
      username
      email
      firstName
      lastName
      gender
      birthDate
    }
  }
`);
